(() => {
  // Opens Shopify's sign-in from the cart's Fishe Rewards box. The cart drawer is closed first: while it is open it
  // keeps focus inside itself, so the first tap in the sign-in window would close the cart and drop focus from the
  // email field. The header's own sign-in button is hidden on phones, so a separate one is added to the page.
  if (window.__fisheCartRewards) return;
  window.__fisheCartRewards = true;

  const signIn = () => {
    let account = document.getElementById('fishe-rewards-account');

    if (!account) {
      account = document.createElement('shopify-account');
      account.id = 'fishe-rewards-account';
      account.setAttribute('menu', 'customer-account-main-menu');
      account.style.cssText = 'position:fixed;inset-block-start:0;inset-inline-start:0;width:1px;height:1px;overflow:hidden;clip-path:inset(50%)';
      document.body.appendChild(account);
    }

    return customElements.whenDefined('shopify-account').then(() => {
      if (typeof account.showModal !== 'function') throw new Error('Sign-in unavailable');
      account.showModal();
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-fishe-rewards-login]') : null;
    if (!button) return;

    event.preventDefault();

    const fallback = () => { window.location.href = button.dataset.loginUrl || '/account/login'; };

    if (!customElements.get('shopify-account')) {
      fallback();
      return;
    }

    const drawer = button.closest('cart-drawer');
    const open = () => signIn().catch(fallback);

    if (!drawer || !drawer.open || typeof drawer.hide !== 'function') {
      open();
      return;
    }

    let done = false;
    const once = () => {
      if (done) return;
      done = true;
      open();
    };

    drawer.addEventListener('dialog:after-hide', once, { once: true });
    setTimeout(once, 900);
    drawer.hide();
  });
})();
